import { Transition } from "@headlessui/react";
import axios from "axios";
import { useEffect, useState } from "react";
import { FaBell } from "react-icons/fa";
import { toast } from "react-toastify";
import api from "../../api";
import SwitchRow from "../shared/SwitchRow";

export default function NotificationSettingsRow() {
  const [notificationsActive, setNotificationsActive] = useState(true);
  const [notifyProjectOwner, setNotifyProjectOwner] = useState(true);
  const [notifyProjectMember, setNotifyProjectMember] = useState(true);
  const [notifyMention, setNotifyMention] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getSettings();
  }, []);

  async function getSettings() {
    try {
      setLoading(true);
      const { data } = await api.notification.getNotificationSettings();
      if (data.result) {
        console.log(data.result);
        setNotificationsActive(data.result.emailEnabled);
        setLoading(false);
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error(
          "Something really went wrong, you might want to contact support!"
        );
      }
    }
  }

  async function updateSettings({ emailEnabled }: { emailEnabled: boolean }) {
    try {
      const { data } = await api.notification.updateNotificationSettings({
        emailEnabled,
      });
      if (data.result) {
        setNotificationsActive(data.result.emailEnabled);
        toast.success("Updated Email preferences");
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error(
          "Something really went wrong, you might want to contact support!"
        );
      }
    }
  }

  function LabeledCheckbox({
    label,
    onChange,
    checked,
  }: {
    label: string;
    onChange: () => void;
    checked: boolean;
  }) {
    return (
      <div className="flex items-center">
        <input
          checked={checked}
          onChange={onChange}
          id="remember-me"
          name="remember-me"
          type="checkbox"
          className="h-4 w-4 text-red-600 focus:ring-red-500 border-slate-300 rounded"
        />
        <label
          htmlFor="remember-me"
          className="ml-2 text-slate-700 text-sm font-semibold"
        >
          {label}
        </label>
      </div>
    );
  }

  return (
    <SwitchRow
      title={"Email Notifications"}
      icon={<FaBell size={20} className="mr-2 text-red-700" />}
      isActive={notificationsActive}
      onChange={() => {
        updateSettings({
          emailEnabled: !notificationsActive,
        });
      }}
    >
      <span className="text-slate-500 text-sm">
        {
          "When Notifications are activated, you will be notified via email about relevant changes on projects, files or comments."
        }
      </span>
      <Transition
        className="mt-4"
        show={notificationsActive}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <span className="text-sm text-slate-500">Get email updates when:</span>
        <div className="space-y-2 mt-2">
          <LabeledCheckbox
            label="You're the project owner"
            checked={notifyProjectOwner}
            onChange={() => null}
            // onChange={() => setNotifyProjectOwner(!notifyProjectOwner)}
          />
          <LabeledCheckbox
            label="You're a member of the project"
            checked={notifyProjectMember}
            onChange={() => null}
            // onChange={() => setNotifyProjectMember(!notifyProjectMember)}
          />
          <LabeledCheckbox
            label="Someone mentions you"
            checked={notifyMention}
            onChange={() => null}
            // onChange={() => setNotifyMention(!notifyMention)}
          />
        </div>
      </Transition>
    </SwitchRow>
  );
}
